<script setup>
import ActionButton from "@/components/utils/ActionButton.vue";
import Table from "@/components/utils/Table.vue";
import { actions } from "@/utils/constants";
import { getFormattedMoney } from "@/utils/functions";

const props = defineProps({
  properties: {
    type: Array,
    default: null,
  },
  propertiesNotEmpty: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
</script>

<template>
  <Table
    :headers="[
      { text: 'PRN No', value: 'prn' },
      { text: 'LR Number', value: 'lr_no' },
      { text: 'Block / Plot Number', value: 'block_plot_no' },
      { text: 'Sub County', value: 'sub_county' },
      { text: 'Outstanding Amount', value: 'outstanding_amount' },
      { text: 'Created At', value: 'created_at' },
      { text: 'Status', value: 'status' },
      { text: 'View', value: 'view', action: true },
      { text: 'Pay Rates', value: 'pay_rates', action: true },
    ]"
    :items="properties"
    :loading="loading"
    emptyText="No plots to show"
    headClasses="primary white--text"
  >
    <template #item.block_plot_no="{ item: property }">
      {{ property.block_no }}/{{ property.plot_no }}
    </template>

    <template #item.sub_county="{ item: property }">
      {{ property.sub_county.sub_county_name }}
    </template>

    <template #item.created_at="{ item: property }">
      {{ formatDate(property.created_at) }}
    </template>

    <template #item.status="{ item: property }">
      {{ property.work_flow_status?.status_name }}
    </template>

    <template #item.outstanding_amount="{ item: property }">
      {{ getFormattedMoney(property?.rates?.current_balance) }}
    </template>

    <template #item.view="{ item: property }">
      <ActionButton
        :action="actions.view"
        inTable
        @click="$emit('viewPropertyClicked', property)"
      />
    </template>

    <template #item.pay_rates="{ item: property }">
      <ActionButton
        :action="actions.payPropertyRates"
        inTable
        @click="$emit('payRatesClicked', property)"
      />
    </template>
  </Table>
</template>
